import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Select from 'react-select';
import styled from 'styled-components';
import { getEnterpriseTableSlice, getJobMappingSlice } from '../../../store/redux/slices/enterpriseSlice';

const Wrapper = styled.div`
  width: 96%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-bottom: 85px;
`;
const Header = styled.div`
    width: 117px;
    height: 30px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    line-height: 30px;
    text-transform: capitalize;
    color:rgba(0, 0, 0, 1);
    margin-bottom: 20px;
`;
const LoaderDiv = styled.div`

& > div {
height:250px;
}
`;
const LogoImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 8px 0px #a2a2a23d;
  border: 1px solid #d9d9d9;
  width: 43px;
  height: 42px;
  border-radius: 5px;
  & svg {
    width: 20px;
    height: 20px;
    padding-top: 5px;
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  gap: 30px;
  font-size: 15px;
  font-weight: 600;
  padding: 30px 0px;
`;
const ContainerWithoutPadding = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  gap: 30px;
  font-size: 15px;
  color: #2a2929;

  font-weight: 600;
  padding: 0px 0px 30px 0px;
`;
const StyledInput = styled.input`
  min-width: 375px;
  min-height: 30px;
  width: 440px;
  padding-right: 35px;
  border: 1px solid #ccc;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: green;
  }
`;
const ContainerInput = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  font-size: 15px;
  font-weight: 600;
  font-family: Inter;

  & input {
    box-shadow: 0px 0px 8px 0px #a2a2a23d;
    border: 1px solid #d9d9d9;
    margin-top: 5px;
    margin-left: -3px;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    color: #636363;

    padding: 5px 10px;
    border-radius: 5px;
  }
`;
const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const Td = styled.td`
  padding: 10px 12px;
  color: #29292a;
  white-space: nowrap;
  height: 100px;
  background-color: ${(props) => (props.highlight ? '#fff0f0' : 'inherit')};
  border-bottom: ${(props) =>
        props.highlight ? '1px solid red' : '1px solid #B5B5B5'};
  font-family: Inter;
  font-weight: 400;
  text-wrap: wrap;
  font-size: 14px;
  text-align: left;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 2rem;
`;
const PageInfo = styled.div`
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content:center;
`;

const Th = styled.th`
  background: '#9ABFC233';
  padding: 12px;
  border-bottom: 1px solid #b5b5b5;
  text-align: center;
  color: #000000;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
`;

function ReviewsTab({
    resetFlag = false,
    download,
    showReport,
    startDate = '',
    endDate = '',
    preview_uuid = '',
    job_id,
    email_id,
    filteredReviews,
    channel,
    min = '',
    max = '',
    hideDropdown,
    formatValue = 'dd-MM-yyyy',
    search_type = '',
}) {
    const [currentPage, setCurrentPage] = useState(1);
    const dispatch = useDispatch();
    const rowsPerPage = 5;
    const { enterprise_table_headers, enterprise_table_body } = useSelector((state) => state.enterprise) || null;

    useEffect(() => {
        dispatch(getJobMappingSlice({ job_id: job_id }))

        dispatch(getEnterpriseTableSlice({ job_id: job_id }))
    }, [job_id]);

    const totalPages = Math.ceil(enterprise_table_body?.length / rowsPerPage);
    const paginatedData = enterprise_table_body?.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    const pageOptions = Array.from({ length: totalPages }, (_, i) => ({
        value: i + 1,
        label: `${i + 1}`,
    }));

    console.log(enterprise_table_headers, enterprise_table_body, "enterprise_table_headers");

    return (
        <Wrapper>
            <Header>Detailed Issues </Header>

            <Table>
                <thead
                    style={{
                        border: '1px solid var(--Input-field-2, #b5b5b5)',
                        height: '48px',
                    }}
                >
                    <tr
                        style={{
                            background: '#9ABFC233',
                        }}
                    >
                        {Object.entries(enterprise_table_headers?.content || {}).map(([key, value]) => (
                            <Th key={key}>{value?.name}</Th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {paginatedData?.map((row) => (
                        <tr key={row.data_id}>
                            {Object.keys(enterprise_table_headers?.content || {}).map((key) => {
                                const value = row[key];
                                const isEmpty = value === null || value === undefined;
                                const isDate = key.includes('created_at') && !!value;

                                if (isDate) {
                                    const dateObj = new Date(value);
                                    const dateStr = dateObj.toLocaleDateString('en-GB');

                                    return (
                                        <React.Fragment key={key}>
                                            <Td highlight={!value}>{dateStr}</Td>
                                        </React.Fragment>
                                    );
                                }

                                const isNumber = typeof value === 'number' && !Number.isInteger(value);
                                const formattedValue = isNumber ? value.toFixed(2) : value;
                                return (
                                    <Td key={key} highlight={isEmpty}>
                                        {formattedValue || '--'}
                                    </Td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>

            </Table>

            <PageInfo>
                <div> Page&nbsp;</div>
                <div style={{ minWidth: '80px' }}>
                    <Select
                        options={pageOptions}
                        menuPlacement='auto'
                        menuPosition='fixed'
                        value={pageOptions.find((opt) => opt.value === currentPage)}
                        onChange={(selected) => setCurrentPage(selected.value)}
                        styles={{
                            container: (base) => ({
                                ...base,
                                width: '75px',
                            }),
                            control: (base, state) => ({
                                ...base,
                                minHeight: '36px',
                                width: '75px',
                                borderRadius: '8px',
                                border: '1px solid #DDDDDD',
                                boxShadow: state.isFocused ? '0 0 0 1px #4caf50' : 'none',
                                borderColor: state.isFocused ? '#4caf50' : '#DDDDDD',
                                '&:hover': {
                                    borderColor: '#4caf50',
                                },
                            }),

                            menu: (base) => ({
                                ...base,
                                width: '70px',
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                    ? '#2D8955'
                                    : state.isFocused
                                        ? '#a5d6a7'
                                        : 'white',
                                color: state.isSelected ? 'white' : 'black',
                                '&:hover': {
                                    backgroundColor: '#a5d6a7',
                                },
                            }),
                            dropdownIndicator: (base, state) => ({
                                ...base,
                                color: state.isFocused ? '#dddddd' : '#666',
                            }),
                            indicatorSeparator: () => ({
                                display: 'none',
                            }),
                        }}
                        isSearchable={false}
                    />
                </div>
                <div> &nbsp;of {totalPages}</div>
            </PageInfo>

        </Wrapper>
    );
}

export default ReviewsTab;
